import { QuestionDetail } from "../../../../../type";
import { hasVisibleText } from "../../../../../util/htmlUtils";
import { getQuestionsToDisplay, hasAnyExplanation, shouldShowStringAnswer } from "../../../../../util/questionDisplayUtils";

const wrapInParagraph = (html: string): string =>
  html.startsWith("<") ? html : `<p>${html}</p>`;

const buildQuestionHtml = (question: QuestionDetail): string => {
  let content = `<li>${question.questionText}</li>`;

  if (shouldShowStringAnswer(question)) {
    content += wrapInParagraph(question.answer);
  }

  if (question.explanation && hasVisibleText(question.explanation)) {
    content += wrapInParagraph(question.explanation);
  }
  return content;
};

export const buildFeedbackDetails = (feedback: {
  context: string;
  questions?: QuestionDetail[] | null;
}): string => {
  const displayable = getQuestionsToDisplay(feedback.questions);
  if (displayable.length === 0) {
    return feedback.context;
  }
  const questionsHtml = displayable.map(buildQuestionHtml).join("");
  const hasContext = feedback.context && hasVisibleText(feedback.context);
  if (!hasAnyExplanation(displayable) && hasContext) {
    return questionsHtml + wrapInParagraph(feedback.context);
  }
  return questionsHtml;
};
